<template>
    <div class="bg-grey-100" style="min-height:95vh">
        <div class="p-12 container">
            <div class="relative">
                <h1 class="text-blue text-3xl text-center">
                    Our Cloud Server Plans
                </h1>
            </div>
            <hr class="border-green w-8 mb-12 mx-auto">

                <vdc-alert></vdc-alert>

            <div>
                <h4>Essentials<strong style="color:#bed734">Plus</strong></h4>
                <p>These servers provide the ideal balance between CPU, memory and storage. They are suitable for running a wide variety of enterprise workloads, such as website hosting, application servers, small and medium-sized databases, Kubernetes cluster nodes, or test/staging environments.</p>

                <sau-dynamic-table :data="essentialServers" :config="tableConfig">
                    <template #table-header>
                        <tr>
                            <th v-for="(header, index) in tableHeaders" :key="`ep-h-${index}`">{{ header }}</th>
                        </tr>
                    </template>

                    <template v-slot="{ item }">
                        <tr>
                            <td>{{ item.name }}</td>
                            <td>{{ productSpecifications(item).memory }}</td>
                            <td>{{ productSpecifications(item).cpu }}</td>
                            <td>{{ productSpecifications(item).storage }}</td>
                            <td>{{ productSpecifications(item).data }}</td>
                            <td>{{ productPrice(item) }}</td>
                            <td class="text-center">
                                <button class="btn btn-link p-0 border-none" @click="selectProduct(item)">Select</button>
                            </td>
                        </tr>
                    </template>
                </sau-dynamic-table>
            </div>

            <div class="mt-10">
                <h4>Storage<strong style="color:#bed734">Plus</strong></h4>
                <p>Designed for enterprise workloads that require large data storage and a high level of read/write performance. They are well suited for large relational and NoSQL databases, big data processing, data warehousing and data lakes, or other applications with high storage requirements.</p>

                <sau-dynamic-table :data="storageServers" :config="tableConfig">
                    <template #table-header>
                        <tr>
                            <th v-for="(header, index) in tableHeaders" :key="`sp-h-${index}`">{{ header }}</th>
                        </tr>
                    </template>

                    <template v-slot="{ item }">
                        <tr>
                            <td>{{ item.name }}</td>
                            <td>{{ productSpecifications(item).memory }}</td>
                            <td>{{ productSpecifications(item).cpu }}</td>
                            <td>{{ productSpecifications(item).storage }}</td>
                            <td>{{ productSpecifications(item).data }}</td>
                            <td>{{ productPrice(item) }}</td>
                            <td class="text-center">
                                <button class="btn btn-link p-0 border-none" @click="selectProduct(item)">Select</button>
                            </td>
                        </tr>
                    </template>
                </sau-dynamic-table>
            </div>
        </div>
    </div>
</template>

<script>
import VdcAlert from "@js/components/order/partials/VdcAlert";
import SauTable from "@js/components/utilities/SauTable";

export default {
    props: {
        products: Array,
        updating: Boolean,
    },

    components: {
        VdcAlert,
        'sau-dynamic-table': SauTable
    },

    inject: [
        'reset',
        'setProductId',
        'productPrice',
        'productSpecifications',
    ],

    data() {
        return {
            tableHeaders: ['', 'Memory', 'vCPUs', 'NVMe Storage', 'Transfer', '$/MO (Ex. GST)', ''],
            tableConfig: {
                paginator: {
                    enabled: false,
                    itemsPerPage: 25,
                    page: 1,
                },
            },
        }
    },

    methods: {
        selectProduct(product) {
            this.setProductId(product.id);
            this.$router.push(`/order/vps/options`);
        },
    },

    computed: {
        essentialServers() {
            return this.products.filter(p => p.name && p.name.startsWith('e'))
        },
        storageServers() {
            return this.products.filter(p => p.name && p.name.startsWith('s'));
        }
    }
}
</script>
<style lang="scss" scoped>
    table td {
        padding: 0.5rem;
    }
</style>
